/**
 * Cookie utility functions for managing browser cookies
 */

/**
 * Sets a cookie with the given name, value, and max age in days
 * @param name - The name of the cookie
 * @param value - The value to store
 * @param maxAgeDays - Number of days until the cookie expires
 */
export const setCookie = (name: string, value: string, maxAgeDays: number): void => {
    const maxAgeSeconds = maxAgeDays * 24 * 60 * 60;
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAgeSeconds}; path=/; SameSite=Lax`;
};

/**
 * Gets a cookie value by name
 * @param name - The name of the cookie to retrieve
 * @returns The cookie value or null if not found
 */
export const getCookie = (name: string): string | null => {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
        }
    }
    return null;
};

/**
 * Deletes a cookie by name
 * @param name - The name of the cookie to delete
 */
export const deleteCookie = (name: string): void => {
    document.cookie = `${name}=; max-age=0; path=/; SameSite=Lax`;
};
